export * from "./results.component";
